import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/tick.svg';
import { mapGetters } from 'vuex';
import optinProductAvailabilityMutation from '@/graphql/mutation/optinProductAvailability.gql';
import isNewProduct from '~/const/patch/newProducts';
import { validateEmail } from '~/helpers/validation-helper';
export default {
  name: 'TheEmailForm',
  props: {
    locale: {
      type: Object,
      required: true
    },
    reference: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      userEmail: '',
      hasError: false,
      isComplete: false,
      needsChecking: false,
      alertFormMessage: '',
      xhrUri: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    sharedEnv: 'sharedEnv/getSharedEnv'
  })), {}, {
    comingSoonLabel: function comingSoonLabel() {
      return isNewProduct(this.reference) ? 'new_product_stock' : 'product_stock';
    }
  }),
  methods: {
    handleBlur: function handleBlur(event) {
      if (event.target.value === '') {
        this.hasError = false;
      }

      if (!this.isComplete && event.target.value !== '') {
        this.needsChecking = true;
        this.checkEmail();
      }
    },
    checkIfComplete: function checkIfComplete() {
      this.isComplete = validateEmail(this.userEmail);
    },
    checkEmail: function checkEmail() {
      this.hasError = !validateEmail(this.userEmail);
      this.isComplete = !this.hasError;
      return this.isComplete ? validateEmail(this.userEmail) : null;
    },
    createAlertDispo: function createAlertDispo() {
      var _this = this;

      // Quick sanitize before posting email value
      if (!validateEmail(this.userEmail)) {
        return;
      }

      this.$apolloProvider.defaultClient.mutate({
        mutation: optinProductAvailabilityMutation,
        variables: {
          locale: this.locale.iso,
          reference: this.reference,
          email: this.userEmail
        }
      }).then(function (_ref) {
        var isSuccess = _ref.data.optinProductAvailability;
        _this.alertFormMessage = isSuccess ? 'product_form_confirm' : 'product_form_error';
      });
    }
  }
};